/**
 * Created by danielg on 2/14/2019.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("personalization-web-agent-templates/agentFileSharingAnchor.tmpl");
    var Button = require("ui/button/Button");
    var Settings = require("codeTables/settings.json");

    var ENABLED_VALUE = "true";

    var AgentFileSharingAnchorView = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        AgentFileSharingAnchorView = Marionette.ItemView.extend({
            template: template,
            withUIComponents: true,
            className: "default-agent-file-sharing-anchor-view anchor hide",
            ui: {
                enabledText: ".current-status-text-current",
                editButton: ".edit-button"
            },
            uiComponents: {
                editButton: {
                    type: Button,
                    options: {
                        el: "view.ui.editButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events: {
                        "click": "_onEditButtonClick"
                    }
                }
            },

            initialize: function (options) {
                this.anchorSelector = options.anchorSelector;
                this.featureId = options.featureId;
            },

            setValues: function(options){
                this.ui.enabledText.text(this._getStatusText(options.settingsCollection.get(Settings.SETTING_ID.AGENT_FILE_SHARING_ENABLED).getValue() === ENABLED_VALUE));
                this.$el.removeClass("hide");
            },

            _getStatusText: function(enabled){
                return enabled ?
                    LE.translator.translate("LEPersonalization.webAgent.fileSharing.anchor.enabled.text")
                    : LE.translator.translate("LEPersonalization.webAgent.fileSharing.anchor.disabled.text");
            },

            onRender: function () {
            },

            _onEditButtonClick: function () {
                this.trigger("agentFileSharing:navigateToFeatureEdit");
            }


        });
    });

    return AgentFileSharingAnchorView;

});
